import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { SearchInput } from '../search-input/search-input';
export var searchContainerKey = 'search-container';
var SearchContainer = /** @class */ (function (_super) {
    __extends(SearchContainer, _super);
    function SearchContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isScrolled: false
        };
        _this.onSearchTermChange = function (term) { return _this.props.onChange(term); };
        _this.onResetSearchTerm = function () { return _this.props.onChange(''); };
        _this.searchBar = function () {
            var props = _this.props;
            return (React.createElement(SearchInput, { className: 'search-field', placeholder: props.placeholder ? props.placeholder : 'Search', query: props.query, forceExpanded: true, onSearch: props.onChange, onReset: _this.onResetSearchTerm, autoFocus: props.autoFocus }));
        };
        _this.handleScroll = function (e) {
            var state = _this.state;
            if (e.target.scrollTop > 0 && !state.isScrolled) {
                _this.setState({ isScrolled: true });
            }
            else if (e.target.scrollTop === 0 && state.isScrolled) {
                _this.setState({ isScrolled: false });
            }
        };
        return _this;
    }
    SearchContainer.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var showSearchBar = !props.hideSearchBar;
        var classNames = namespacedClassnames(searchContainerKey, props.className, { scrolled: state.isScrolled, searchable: showSearchBar });
        return (React.createElement("div", { className: classNames },
            showSearchBar && React.createElement("div", { className: 'search-header' }, this.searchBar()),
            React.createElement("div", { className: 'search-content', onScroll: this.handleScroll }, this.props.children)));
    };
    return SearchContainer;
}(React.PureComponent));
export { SearchContainer };
//# sourceMappingURL=index.js.map